/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isphonebookenabled3Inputs */

const en_entity_isphonebookenabled3 = /** @type {(inputs: Entity_Isphonebookenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Phone Book Enabled`)
};

const de_entity_isphonebookenabled3 = /** @type {(inputs: Entity_Isphonebookenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressbuch aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Phone Book Enabled" |
*
* @param {Entity_Isphonebookenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isphonebookenabled3 = /** @type {((inputs?: Entity_Isphonebookenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isphonebookenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isphonebookenabled3(inputs)
	return de_entity_isphonebookenabled3(inputs)
});
export { entity_isphonebookenabled3 as "entity_isPhoneBookEnabled" }